import * as yup from 'yup';

const formikSchema = {
  validationSchema: yup.object({
    masterCarrierId: yup.string().required(),
  }),
};

export default formikSchema;
